export default "__VITE_ASSET__DQgCBd3U__"